export enum Codeowners {
  CUSTOMER_INTAKE = 'customer_intake',
  INNOVATION = 'innovation',
}
